













import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ObjectItem } from '../store/types'

@Component
export default class Dropdown extends Vue {
  @Prop({ default: '' }) readonly name!: string | null
  @Prop() readonly current !: ObjectItem
  @Prop() readonly options !: ObjectItem[]
  @Emit('changeValue') changeValue (value: ObjectItem) { return value }

  get selected () {
    return this.current
  }

  set selected (value: ObjectItem) {
    this.changeValue(value)
  }
}
